import Vue from 'vue'
import './plugins/vuetify'
import './plugins/base'
import App from './App.vue'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.min.css'
Vue.config.productionTip = false
sync(store, router)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
